import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChats = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 11.92,
	viewBox: "0 0 12 11.92",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M12,1.48v6.71c0,.81-.67,1.48-1.5,1.48h-3.38l-2.93,2.2c-.19,.14-.45,0-.45-.23v-1.95H1.5c-.83,0-1.5-.65-1.5-1.48V1.48C0,.67,.67,0,1.5,0H10.5c.85,0,1.5,.67,1.5,1.48Zm-1.1,.02c0-.21-.17-.38-.38-.38H1.52c-.21,0-.38,.17-.38,.38v6.75c0,.21,.17,.38,.38,.38h3.38v1.41l1.88-1.41h3.75c.21,0,.38-.17,.38-.38V1.5Zm-6.74,3.38c0,.42-.33,.75-.73,.75s-.73-.33-.73-.75,.31-.75,.73-.75,.73,.33,.73,.75Zm2.62,0c0,.42-.31,.75-.73,.75s-.75-.33-.75-.75,.33-.75,.75-.75,.73,.33,.73,.75Zm2.62,0c0,.42-.33,.75-.73,.75s-.73-.33-.73-.75,.31-.75,.73-.75,.73,.33,.73,.75Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgChats);
export default ForwardRef;
